import React, { useEffect, useRef, useState } from "react";
import Grid from "@mui/material/Grid2";
import { IconButton, List, ListItem, ListItemText } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import {
  TICKETS_MERGED_URL,
  DELETE_MERGED_TICKET_URL,
} from "../../Constants/Constants";
import AxiosInstance from "../../services/AxiosInstance";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import TablePagination from "@mui/material/TablePagination";
import Container from "react-bootstrap/Container";
import Box from "@mui/material/Box";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import { styled } from "@mui/material/styles";
import { useAlert } from "./../alerts//AlertContext";
import AppTableView from "../AppTableView";
import { ThemeProvider } from "../v2/home/theme/ThemeProvider";
import { STATUS_CLOSED_ID } from '../../Constants/StatusConstants'

function MergeTickets(props) {
  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: theme.palette.common.black,
      color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
    },
  }));

  const StyledTableRow = styled(TableRow)(({ theme }) => ({
    "&:nth-of-type(odd)": {
      backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    "&:last-child td, &:last-child th": {
      border: 0,
    },
  }));

  const [data, setData] = useState([]);

  const initialized = useRef(false);
  const showAlert = useAlert();

  useEffect(() => {
    if (!initialized.current) {
      initialized.current = true;
      getMergedTickets();
    }
  }, []);

  const getMergedTickets = () => {
    AxiosInstance.get(TICKETS_MERGED_URL + props.ticketId).then((response) =>
      setData(response.data)
    );
  };

  const handleDeleteTicket = (tkt) => {
    if (data.length === 1) {
      AxiosInstance.get(`${DELETE_MERGED_TICKET_URL}/${props.ticketId}`).then(
        (response) => console.log(response.data)
      );
    }
    AxiosInstance.get(`${DELETE_MERGED_TICKET_URL}/${tkt}`).then((response) =>
      showAlert("Removed ticket  successfully!", "success")
    );
    //setMergeTickets(mergeTickets.filter((_, i) => i !== index));
    setData((mergeTkts) =>
      mergeTkts.filter((item) => item.mergeTicket !== tkt)
    );
  };

  return (
    <ThemeProvider>
      <Box sx={{ padding: "20px", bgcolor: "background.default" }}>
        <fieldset>
          <legend>Merged Tickets</legend>

          <AppTableView
            rows={data.map((row) => ({ ...row, id: row.mergeTicket }))}
            cols={[
              { field: "mergeTicket", headerName: "Ticket Id", flex: 1 },
              {
                field: "action",
                headerName: "Action",
                flex: 1,
                renderCell: (params) => (
                  <IconButton
                    disabled={props.statusId === STATUS_CLOSED_ID}
                    edge="end"
                    onClick={() => handleDeleteTicket(params.row.mergeTicket)}
                  >
                    <DeleteIcon />
                  </IconButton>
                ),
              },
            ]}
            initialPageSize={5}
            rowHeight={80}
          />
        </fieldset>
      </Box>
    </ThemeProvider>
  );
}
export default MergeTickets;
